export const clienteModais = {
  cadastroCliente: 'cadastroCliente',
  visualizacaoCliente: 'visualizacaoCliente',
  cadastroGrupoCliente: 'cadastroGrupoCliente',
  importarCliente: 'importarCliente',
  buscaAvancada: 'buscaAvancada',
};
